/*
 * @flow
 */
import type Orchestrator from '../orchestrator';
import type { UniverseEmbedWidget as EmbedWidget } from '../widget';

export default function reloadWidget(orc: Orchestrator): (widgetId: string, newState: Object) => void {
  return (widgetId: string, newState: Object) => {
    for (let i = 0; i < orc._widgets.length; i ++) {
      const w: EmbedWidget = orc._widgets[i];
      if (w.id() === widgetId) {
        w.reload(newState);
        return;
      }
    }
  };
}



// WEBPACK FOOTER //
// ./src/bootstrap/plugins/reloadWidget.js